import { Box } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { SelectParentEntityList } from '../../screens/EntityManagement/Onboarding/CreateEntity/SelectParentEntityList'

const headTitles: any = [{ title: 'TID' }, { title: 'VPA & QR URL' }]
const tableColumnMapper: any = { 0: 1, 1: 2 }
interface VpaListProps {
  data: any
}
const VpaList = ({ data }: VpaListProps) => {
  const [listData, setData] = useState(data)

  useEffect(() => {
    setData(data)
  }, [data])
  console.log('listData', listData)

  if (listData?.length === 0) {
    return null
  }
  return (
    <Box marginTop={16}>
      <SelectParentEntityList
        title={''}
        hide={false}
        data={data}
        columnFlexMapper={tableColumnMapper}
        headerTitles={headTitles ?? []}
      />
    </Box>
  )
}

export { VpaList }
